import React from 'react'
import { Box, Grid, Theme, Typography, useMediaQuery } from '@mui/material'

import LocationMap from '../../../../shared/components/Location/LocationMap'
import { LatLng } from 'leaflet'
import { getAppTheme } from '../../../../shared/config/getAppTheme'
import DOMPurify from 'dompurify'
import getDataGeography from '../getDataGeography'

const Niederstaucha: React.FC = () => {
  const theme: Theme = getAppTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <>
      <Typography variant='h1'>Niederstaucha</Typography>
      <Typography variant='subtitle1'>Geschichte</Typography>
      <Grid container spacing={2}>
        <Grid item xs={downMd ? 12 : 8} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant='body1'
            dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(getDataGeography('niederstaucha')[0] as string)}` }}
          />
        </Grid>
        <Grid item xs={downMd ? 12 : 4} sx={{ display: 'flex', alignItems: 'center' }}>
          <img src='/images/niederstaucha-siegel.webp' style={{ width: '100%' }} />
        </Grid>
      </Grid>
      <Typography variant='subtitle1'>Rittergut Niederstaucha</Typography>
      <Grid container spacing={2}>
        <Grid item container xs={downMd ? 12 : 4} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <img src='/images/niederstaucha-schloss.jpg' style={{ width: '100%' }} />
        </Grid>
        <Grid item xs={downMd ? 12 : 8} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Typography
            variant='body1'
            dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(getDataGeography('niederstaucha')[1] as string)}` }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant='body1'
            dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(getDataGeography('niederstaucha')[2] as string)}` }}
          />
        </Grid>
      </Grid>
      <Typography variant='subtitle1'>Staucha heute</Typography>
      <Grid container spacing={2}>
        <Grid item xs={downMd ? 12 : 8}>
          <Typography
            variant='body1'
            dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(getDataGeography('niederstaucha')[3] as string)}` }}
          />
        </Grid>
        <Grid item container xs={downMd ? 12 : 4}>
          <img src='/images/staucha-schloss.jpg' style={{ width: '100%', height: 'fit-content' }} />
        </Grid>
      </Grid>
      <Box sx={{ marginTop: '20px' }}>
        <LocationMap
          mapZoom={12}
          label={['Staucha']}
          positions={[new LatLng(51.221710, 13.219993)]}
        />
      </Box>
    </>
  )
}

export default Niederstaucha
